import Command from '@ckeditor/ckeditor5-core/src/command';
import randomUUIDGenerator from '../../src/utils/randomUUIDGenerator.js';
import first from '@ckeditor/ckeditor5-utils/src/first';
import { CkeditorConstants } from "../../src/utils/ckeditorconstants";


const { helperAttributes: { TRACK_CHANGES_EDITING },
  CONTENT_HARMONIZATION: {
    FRBR_EXPRESSION,
    PCICORE_MEDIARESOURCE,
    FRBR_MANIFESTATION,
    FRBR_EMBODIMENT,
    FRBR_PART_OF,
    PCICORE_HASATTACHMENT
  },
  localStorageItem: { baseHrefForLinkPlugin },
  htmlElement: { SPAN },
  PLUGINS: { TRACK_CHANGES },
  COMMANDS: { CMD_TRACK_CHANGES }
} = CkeditorConstants;

export default class InsertVideoCommand extends Command {
  baseHrefForLinkPlugin;
  execute({ value }) {
    this.editor.fire('insertvideo');
    this.isEnabled = false;
    const isTrackChangesEnabled = this.editor.commands.get(CMD_TRACK_CHANGES).value && this.editor.plugins.get(TRACK_CHANGES).isEnabled;
    this.editor.model.change(writer => {
      const selection = this.editor.model.document.selection;
      const schema = this.editor.model.schema;
      const videoType = this.determineVideoTypeForInsertionAtSelection(schema, selection);
      const id = randomUUIDGenerator();
      this.baseHrefForLinkPlugin = this.editor.baseHrefForLinkPlugin;
      const figureTag = writer.createElement('figureTag', {
        id, about: this.baseHrefForLinkPlugin + '#' + id,
        'class': 'media-class'
      });
      const item = value.videoContent[0];
      const parentWrapper = writer.createElement('video', {
        'id': randomUUIDGenerator(),
        'class': 'ck-media-video',
        'controls': 'test',
        'data-cke-ignore-events': 'true',
        'preload': 'none',
        'poster':  item.tenantId
      });      
      writer.appendElement('source', {
        rel: PCICORE_HASATTACHMENT,
        'src': item.src,
        'typeof': `${PCICORE_MEDIARESOURCE} ${FRBR_MANIFESTATION}`,
        'data-node-name': item.name,
        'title': item.title,
        'data-tenant-id': item.tenantId,
      }, parentWrapper);

      const relSpan = writer.createElement(SPAN, {
        rel: FRBR_PART_OF,
        resource: this.baseHrefForLinkPlugin
      })
      writer.append(relSpan, figureTag);
      writer.append(parentWrapper, relSpan);
      if (videoType === 'videoInline') {
        this.editor.model.insertContent(
          figureTag,
          writer.createSelection(selection.getFirstPosition().parent, selection.focus.isAtEnd ? "after" : "before")
        )
        this._addContentHarmonization(writer, figureTag, item);
      } else {
        writer.insert(figureTag, selection.getFirstPosition());
        this._addContentHarmonization(writer, figureTag, item);
        if (isTrackChangesEnabled) {
          const range = writer.createRangeOn(figureTag);
          this.editor.plugins.get(TRACK_CHANGES_EDITING).markInsertion(range);
        }
      }
    });
    this.editor.focus();
  }

  /**
   * Insert a block video if the selection is not in/on block elements or it's on a block widget.
   * A block video should also be inserted into an empty block element
   * (that is not an empty list item so the list won't get split).
   * Otherwise insert an inline video.
   */
  determineVideoTypeForInsertionAtSelection(schema, selection) {
    const firstBlock = first(selection.getSelectedBlocks());
    const blockSelection = !firstBlock || schema.isObject(firstBlock);
    const isEmptyBlock = blockSelection || (firstBlock.isEmpty && firstBlock.name != 'listItem');
    const firstBlockChildNodes = firstBlock._children._nodes[0];
    const isFirstChildFigureTag = isEmptyBlock || (firstBlockChildNodes && firstBlockChildNodes.name && firstBlockChildNodes.name === CkeditorConstants.htmlElement.FIGURETAG);
    return isFirstChildFigureTag ? 'videoBlock' : 'videoInline';
  }

  /**
  * this is private method to add content harmonization
  * @param {Writer} writer 
  * @param {HTMLElement} figureTag 
  * @param {{[key]:value }} item 
  */
  _addContentHarmonization(writer, figureTag, item) {
    const getElement = (props) => writer.createElement(SPAN, {
      ...props
    });
    let src = item.tenantId?.split('/');
    const tenantId = src?.pop();
    writer.append(getElement({
      about: `${src.join('/')}/${tenantId ? tenantId.concat('-1000'): ''}`,
      typeof: `${FRBR_EXPRESSION} ${PCICORE_MEDIARESOURCE}`,
      rel: FRBR_EMBODIMENT,
      resource: item.tenantId
    }), figureTag);
  }
}
